import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Enums } from '../../shared/enums';
import { Utils } from '../../shared/utils';
import { AuthService } from '../../services/auth.service';
import { IBaseModel } from '../../models/base.model';

export const authInterceptor: HttpInterceptorFn = (
    request: HttpRequest<any>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
    const authService = inject(AuthService);
    const toastr = inject(ToastrService);
    const spinner = inject(NgxSpinnerService);

    return next(request).pipe(
        catchError((error): Observable<HttpEvent<any>> => {
            spinner.hide();
                spinner.hide('flow');
                spinner.hide('tinyMceSpinner');

                if (error.status === 401) {
                    authService.login();
                    return next(request);
                }

                // caso o erro detectado seja referente a "sessão" inválida do Acesso Cidadão
                if (!error.ok && error.status === 0) {
                    //procedimento automático de renovação da "sessão" com o Acesso Cidadão
                    let token = encodeURIComponent(btoa(new Date().toISOString()));
                    let loginWindow = window.open(`${window.location.origin}/${Enums.PagesPaths.Home}?s=${token}`, '_blank');
                    setTimeout(() => {
                        let interval = setInterval(() => {
                            if (loginWindow?.location?.href?.includes(token)) {
                                clearInterval(interval);
                                loginWindow.close();
                            }
                        }, 500);
                    }, 5000);

                    toastr.warning(Enums.Messages.AcessoCidadaoExpiredWarning, Enums.Messages.Warning, Utils.getToastrErrorOptions());

                    return next(request);
                }

                if (error.error instanceof ErrorEvent) {
                    // erro client-side ou de rede
                } else if (error.error && error.error.isSuccess != null && error.error.message != null) {
                    return throwError(() => error.error as IBaseModel<any>);
                }

                toastr.error(Enums.Messages.GeneralErrorInterceptor, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return throwError(() => error);
        })
    );
};
